import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Observable, tap, of, catchError, map } from 'rxjs';
import { environment } from '@environment/environment';
import { ActivatedRoute } from '@angular/router';

interface ISaveCardResponse {
  resultCode: string;
  resultMessage?: string;
  errorCode?: string;
  result: {
    paid_amount?: string;
    reversed_amount?: string;
    date_time?: string;
  };
}

@Injectable({
  providedIn: 'root',
})
export class CardAdministrationService {
  callback: EventEmitter<any> = new EventEmitter();
  public requestpayment: any = [];
  public bodyrequestcard: any = [];
  public tokenacces: string = '';
  public tokencard: string = '';
  public email: string = '';
  public afilcard: boolean = false;
  public numbermodule: number = 0;
  public tyc: boolean = false;
  public uploadcard: boolean = false;
  public numberphone: string = '';
  public bindcardgen: string = '**** **** **** ****';
  public expiratesdatecard: string = '';
  private readonly APIURL = environment.api;
  private readonly APICENAM = environment.serviceCENAM;
  private isNational: boolean = false;
  public emailFromDom: string = '';
  public finishpin: boolean = false;
  public tokeNumero: string = '';
  private tokenAuth: string = '';
  public finalServiceResponse: ISaveCardResponse;

  constructor(
    private readonly http: HttpClient,
    private readonly cookie: CookieService,
    private readonly route: ActivatedRoute
  ) {
    this.finalServiceResponse = {
      errorCode: '',
      result: {
        paid_amount: '',
        reversed_amount: '',
        date_time: '',
      },
      resultCode: '',
      resultMessage: '',
    };
  }

  loadSaveProcess(
    transactionIdentifier: string,
    token: string
  ): Observable<any> {
    const bodyRequest = {
      processIdentifier: transactionIdentifier,
      token: token,
    };

    return this.http
      .post(
        `${this.APIURL}/payment/card-administration/validateToken`,
        bodyRequest
      )
      .pipe(
        tap((rspOk: any) => {
          const { resultCode, errorCode, resultMessage, result } = rspOk;
          const expirationDate = new Date();
          expirationDate.setMinutes(
            expirationDate.getMinutes() + environment.cookieExpirationTime
          );
          this.cookie.set('token', rspOk.result.token, expirationDate, '/');
        }),
        catchError((err) => {
          return of({
            resultCode: 'ERROR',
          });
        })
      );
  }

  bindBankCard(bodyRequest: any): Observable<any> {
    return this.http
      .post(`${this.APIURL}/card-administration/save-bank-card`, bodyRequest)
      .pipe(tap((rspOk: any) => {}));
  }

  setIsNational(isNational: boolean) {
    this.isNational = isNational;
  }

  getIsNational() {
    return this.isNational;
  }

  enrollPendingAuth(bodyRequest: any): Observable<any> {
    return this.http
      .post(
        `${this.APIURL}/payment/card-payment/enrollPendingAuth`,
        bodyRequest
      )
      .pipe(
        map((rspOk: any) => {
          return rspOk;
        }),
        catchError((err) => {
          return of({
            error: true,
            responseMessage: 'generic error encountered',
          });
        })
      );
  }

  validateAuthResult(bodyRequest: any): Observable<any> {
    return this.http
      .post(
        `${this.APIURL}/payment/card-payment/validateAuthResult`,
        bodyRequest
      )
      .pipe(
        map((rspOk: any) => {
          console.log('respondio servicio validateAuthResult');
          return rspOk;
        }),
        catchError((err) => {
          return of({
            error: true,
            responseMessage: 'generic error encountered',
          });
        })
      );
  }

  setAuthToken(tokenAuth: string) {
    this.tokenAuth = tokenAuth;
  }

  getAuthToken() {
    return this.tokenAuth;
  }
}
